export enum FilterEventEnum {
  AllEvents = 1,
  MyEvents = 2,
  AllUnpublishedEvents = 3,
  AllRequestedChanges = 4,
  Categories = 5
}
